import React from 'react';

import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import CustomButton from '~/components/UI/CustomButton/CustomButton';
import {
  MIDDLE_MARGIN_PX,
  SMALL_MARGIN_PX,
  SMALL_RADIUS_PX,
  SUBMIDDLE_MARGIN_PX,
  useIsWidthUp,
} from '~/theme';

const BannerWithButton = ({ title, subtitle, caption, onClick, buttonCaption, mobileIcon }) => {
  const isMobile = !useIsWidthUp('md');

  return (
    <Wrapper>
      <Info data-testid="bannerInfo">
        <Caption>{caption}</Caption>
        <Title>{title}</Title>
        <Subtitle>{subtitle}</Subtitle>
      </Info>
      {isMobile ? (
        <MobileIconWrapper onClick={onClick}>{mobileIcon}</MobileIconWrapper>
      ) : (
        <StyledCustomButton data-testid="bannerButton" onClick={onClick}>
          {buttonCaption}
        </StyledCustomButton>
      )}
    </Wrapper>
  );
};

export default BannerWithButton;

const Wrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 685px;
  padding: ${SMALL_MARGIN_PX};
  border-radius: ${SMALL_RADIUS_PX};
  background: ${({ theme }) => theme.palette.common.card.background.dark};

  ${({ theme }) => theme.breakpoints.up('sm')} {
    padding: ${SMALL_MARGIN_PX} ${SUBMIDDLE_MARGIN_PX};
  }
  ${({ theme }) => theme.breakpoints.up('md')} {
    width: unset;
    max-width: unset;
    margin-left: auto;
  }
  ${({ theme }) => theme.breakpoints.up('lg')} {
    min-width: 685px;
  }
`;
const Subtitle = styled('span')`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.common.text.questionDescription};
`;
const Title = styled(Typography)`
  font-size: 18px;
  line-height: 22px;
`;
const Caption = styled('span')`
  display: block;
  font-size: 14px;
  font-weight: 700;
  color: ${({ theme }) => theme.palette.common.blockBackground.lightText};
`;
const Info = styled('div')`
  margin-right: ${MIDDLE_MARGIN_PX};
`;
const MobileIconWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 54px;
  min-width: 54px;
  height: 54px;
  box-sizing: border-box;
  background: ${({ theme }) => theme.palette.common.card.chat};
  border: 3px solid ${({ theme }) => theme.palette.common.button.collapseSecondary};
  border-radius: 50%;
`;
const StyledCustomButton = styled(CustomButton)`
  flex-shrink: 0;
`;
